import React, { useState, useEffect } from "react";
import { Modal } from "@appkit4/react-components/modal"
import ModalFooter from "@appkit4/react-components/esm/modal/ModalFooter";
import Edit from "./edit";
import displayToastMessage from "../../../Common/Alert/displayToastMessage";
import PropTypes from 'prop-types';
import useHttp from "../../../../hooks/useHttp";
import APIService from "../../../../services/apiAxiosService";
import {Table, Column} from "@appkit4/react-components/table";
import { Input } from "@appkit4/react-components/field";
import { Pagination } from "@appkit4/react-components/pagination";
export default function ViewIssue(props) {
  let { viewIssues, vendors, assessment, risk, analyst, reload, reloadIssue } =
    props;
  const [messageScreen, setMessageScreen] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [view, setView] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState([]);
  const [current, setCurrent] = useState(1);
  const [totalPage, setTotalPage] = useState(500);
  const [updateIssueId, setUpdateIssueId] = useState();
  const { sendRequest: getIssueByIdAPI } = useHttp();

  useEffect(() => {
    setMessageScreen(false);
  }, [props.reset]);

  useEffect(() => {
    setTableData(viewIssues);
    setFilter(viewIssues);
    let totalPageLength = Math.ceil((viewIssues?.length)/10);
        if (totalPageLength === 0) {
          totalPageLength = 1;
        }
      setTotalPage(totalPageLength);
  }, [viewIssues]);

  useEffect(() => {
    const result = tableData?.filter((manageIssueList) => {
      let searchParam = `ISSUE${manageIssueList?.issue_action_id.toString()}`
      return searchParam.toLowerCase().match(search.toLocaleLowerCase());
    });
    setFilter(result);
    let totalPageLength = Math.ceil((result?.length)/10);
        if (totalPageLength === 0) {
          totalPageLength = 1;
        }
      setTotalPage(totalPageLength);
  }, [search]);

  const handleCancel = () => {
    setModalVisible(false);
    setSearch("");
  };
  const handleConfirm = () => {
    setModalVisible(false);
    let msg = "Record deleted successfully";
    displayToastMessage(msg, "success");
  };

  const getIssueDetailsById = async (id,actionId) => {
    await getIssueByIdAPI(APIService.getIssueById(id,actionId), (result) => {
      setUpdateIssueId(result.MSG[0]);
      setMessageScreen(true);
    });
  };
  const sendBackHandler = () => {
    setMessageScreen(false);
    setSearch("");
    reload();
    reloadIssue();
  };

  const sortFuncForOrder1 = (a, b) => {
    const firstOrderId = (a.issue_action_id.toString()).charAt(1);
    const secondOrderId = (b.issue_action_id.toString()).charAt(1);
    return firstOrderId > secondOrderId ? 1 : -1;;
}

  const sortFuncForOrder2 = (a, b) => {
    const firstOrderId = (a.issue_action_id.toString()).charAt(1);
    const secondOrderId = (b.issue_action_id.toString()).charAt(1);
    return firstOrderId < secondOrderId ? 1 : -1;;
  }

  const renderIssueID = (row) => {
    let issueID = "ISSUE"+row?.issue_action_id;
  return <div>{issueID}</div>
  }

  const renderStatusCell = (row) => {
    let stylesClass;
    switch (row._status) {
      case "Expired":
      stylesClass = "Expired-status";
      break;
      case "Open":
      stylesClass = "Open-status";
      break;
      case "Close":
      stylesClass = "Close-status";
      break;
      default:
      stylesClass = "";
    }
    let className = "bia-status " + stylesClass;
    return <div class={className}>{row._status}</div>
  }


  const renderActionCell = (row) => {
    if(row._status !='Close' ){
      
      return(
        <>
                <span class="Appkit4-icon icon-view-fill action-icon pointer" title="View issue" onClick={() => handleViewButton(row)}></span>&nbsp;

        <span class="Appkit4-icon icon-edit-fill action-icon pointer" title="Edit The issue" onClick={() => handleEditButton(row)}></span>&nbsp;
        </>
      )
    }else{

  
    return (
      <>
                <span class="Appkit4-icon icon-view-fill action-icon pointer" title="View issue" onClick={() => handleViewButton(row)}></span>&nbsp;

      </>
    )
  }
  }

  const handleViewButton = (row) => {
    getIssueDetailsById(row?.issue_id,row?.issue_action_id);
    setView(false);
    setSearch("");
  }

  const handleEditButton = (row) => {
    getIssueDetailsById(row?.issue_id,row?.issue_action_id);
    setView(true);
    setSearch("");
  }

  const handleDeleteButton = (row) => {
    displayToastMessage("Cannot delete the records", "error");
  }

  return (
    <div className="">
      {messageScreen ? (
        <Edit
          handleBack={sendBackHandler}
          updateIssueId={updateIssueId}
          vendors={vendors}
          assessment={assessment}
          risk={risk}
          View={view}
          analyst={analyst}
          reload={reload}
        />
      ) : (
        <div className="col-lg-12 mt-3 pl-1">
          {tableData.length > 0 ? (
            <Input
            type="text"
            title= "Search Issue ID"
            value={search}
            className="ap-field-wrapper-tableSearch"
            onChange={(e) => setSearch(e)}
          /> 
          ) : ""}
              <div className="ap-table-demo">
              <Table originalData={filter} hasTitle currentPage={current} pageSize={10} className={filter.length === 0 ? "" : "biaTableBU"}>
                    <Column field="issue_action_id" sortKey={filter.length === 0 ? "" : "issue_action_id"} sortFunc1={sortFuncForOrder1} sortFunc2={sortFuncForOrder2} renderCell={renderIssueID} className={filter.length === 0 ? "" : "oneFifteen"}>Issue ID</Column>
                    <Column field="_status" sortKey={filter.length === 0 ? "" : "_status"} renderCell={renderStatusCell}>Status</Column>
                    <Column field="vendor_name" sortKey={filter.length === 0 ? "" : "vendor_name"} className={filter.length === 0 ? "" : "oneSeventy"}>Third Party Name</Column>
                    <Column field="created_date" sortKey={filter.length === 0 ? "" : "created_date"} className={filter.length === 0 ? "" : "oneFiftyFive"}>Issue Start Date</Column>
                    <Column field="issuedue_date" sortKey={filter.length === 0 ? "" : "issuedue_date"} className={filter.length === 0 ? "" : "oneFiftyFive"}>Issue End Date</Column>
                    <Column field="control_name" sortKey={filter.length === 0 ? "" : "control_name"} className={filter.length === 0 ? "" : "oneEighty"}>Associated Controls</Column>
                    <Column field="issue_rating" sortKey={filter.length === 0 ? "" : "issue_rating"} className={filter.length === 0 ? "" : "oneThirty"}>Rating</Column>
                    <Column field="issue_id"
                    className={filter.length === 0 ? "" : "oneTwenty"}
                    renderCell={renderActionCell}
                    >Action</Column>
                </Table>
                {filter.length === 0 ? (
                  <div className="noData">
                  No data available in table
                  </div>
                  ) : ("")}
                  </div>
                <Pagination
                  defaultCurrent={1}
                  current={current}
                  total={totalPage}
                  onPageChange={(page) => setCurrent(page)}
                >
                </Pagination>
            </div>
      )}
      <div>
        <Modal
          className="baseline-modal-showcase"
          visible={modalVisible}
          onCancel={handleCancel}
          bodyStyle={{ maxHeight: "280px" }}
          footerStyle={{ paddingTop: "8px", marginTop: "-8px" }}
          modalStyle={{ width: "49.75rem", maxHeight: "fit-content" }}
        >
          <div className="modal-title">
            Are you sure you want to delete the Request?
          </div>
          <ModalFooter>
            <div className="modal-footer">
              <button
                type="button"
                className="cancel-button"
                onClick={handleCancel}
              >
                No
              </button>

              <button
                type="submit"
                className="save-button m-l-2"
                onClick={() => handleConfirm()}
              >
                Yes
              </button>
            </div>
          </ModalFooter>
        </Modal>
      </div>
    </div>
  );
}
ViewIssue.propTypes = {
  vendors: PropTypes.array,
  viewIssues: PropTypes.array,
  risk: PropTypes.array,
  reset: PropTypes.bool,
  reloadIssue: PropTypes.func,
  reload: PropTypes.func,
  assessment: PropTypes.array,
  analyst: PropTypes.array

}
